import { FormControl, FormLabel, Text } from "@chakra-ui/react";
import React, { FC } from "react";
import { FieldRenderProps } from "react-final-form";
import { DefaultFieldProps } from "../../types";
import Select from "react-select";
import { isEmpty } from "lodash";

type Option = {
  value: any;
  label: any;
};
interface MeasurementUnitFieldProps extends DefaultFieldProps {
  defaultVal?: any;
  options: Option[];
  menuPortalTarget?: any;
  selectMenuPosition?: any;
  selectMenuPortalzIndex?: number;
  selectCustomStyles?: any;
  isDisabled?: boolean;
  isLoading?: boolean;
  isClearable?: boolean;
  onChange?: () => void;
  formatGroupLabel?: any;
}

const MeasurementUnitField: FC<
  FieldRenderProps<MeasurementUnitFieldProps & any>
> = (props) => {
  const {
    defaultVal,
    formGroupProps,
    labelProps,
    errorProps,
    label,
    meta,
    input,
    options,
    menuPortalTarget = null,
    selectMenuPosition = "absolute",
    selectMenuPortalzIndex = 3000,
    selectCustomStyles,
    isDisabled,
    isLoading,
    isClearable,
    onChange,
    formatGroupLabel,
  } = props;

  const nestedOptions: any = [];
  if (!isEmpty(options.map((option: any) => option.options))) {
    options.forEach((option: any) =>
      option?.options.forEach((category: any) => {
        nestedOptions.push(category);
      })
    );
  }

  const value = nestedOptions.find(
    (option: any) => option.value === input.value
  );

  return (
    <FormControl {...formGroupProps} position="relative">
      <FormLabel {...labelProps}>{label}</FormLabel>
      <Select
        {...input}
        value={value}
        className="basic-single"
        classNamePrefix="select"
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        styles={{
          ...selectCustomStyles,
          menuPortal: (styles: any) => {
            return {
              ...styles,
              zIndex: selectMenuPortalzIndex,
            };
          },
        }}
        defaultValue={defaultVal}
        isSearchable={true}
        options={options}
        noOptionsMessage={() => "No Options available."}
        menuPortalTarget={menuPortalTarget}
        menuPosition={selectMenuPosition}
        onChange={(val) => {
          input.onChange(val.value);
          onChange && onChange(val.value);
        }}
        formatGroupLabel={formatGroupLabel}
      />
      {meta.error && meta.touched && (
        <Text
          {...errorProps}
          color="red.300"
          fontSize="sm"
          textAlign="end"
          mx="3"
          position="absolute"
          right={0}
        >
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default MeasurementUnitField;
